import React, {forwardRef, useImperativeHandle, useRef} from 'react';

import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './tabs.component.module.styl';

import type {ReactNode} from 'react';


const classnames = hashedClasses(styles);

type Props = {
    children: ReactNode,
};

/**
 * Renders caption for the tab, with bold text on hover
 * */
export const TabCaption = forwardRef(({children}: Props, ref) => {

    const captionRef = useRef<HTMLSpanElement>(null);

    useImperativeHandle(ref, () => captionRef.current);

    return (
        <span className={classnames.tabs__caption} ref={captionRef}>
            {children}
        </span>
    );
});

TabCaption.displayName = 'TabCaption';

